import script from "./FloatingDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingDialog.vue?vue&type=script&setup=true&lang=js"

import "./FloatingDialog.vue?vue&type=style&index=0&id=09ed4d12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ed4d12"]])

export default __exports__